// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i26O","rootMobile":"styles_rootMobile__2310x"};